import type { TFunction } from 'i18next'
import type { PushTeaser, PushTeaserEntry } from '../services/pushTeaser'

function climbWord(climbType: 'boulder' | 'route' | null): string {
  return climbType ?? 'mixed'
}

function entryPhrase(t: TFunction, entry: PushTeaserEntry): string | null {
  switch (entry.kind) {
    case 'place_climbs':
      return t(`pushNudge.teaser.placeClimbs.${climbWord(entry.climb_type)}`, { count: entry.count, name: entry.location_name })
    case 'followed_climbs':
      return t(`pushNudge.teaser.followedClimbs.${climbWord(entry.climb_type)}`, { count: entry.count, name: entry.user_name })
    case 'announcements':
      return t('pushNudge.teaser.announcements', { count: entry.count, name: entry.location_name })
    case 'first_tops':
    case 'comments':
    case 'followers':
      return t(`pushNudge.teaser.${entry.kind}`, { count: entry.count })
    default:
      // A kind this version of the app has no words for.
      return null
  }
}

/**
 * The card's one line: what arrived this week, else what the places and
 * people they follow would bring, else what push is for at all.
 */
export function teaserSentence(t: TFunction, teaser: PushTeaser | null): string {
  const phrases = (teaser?.missed ?? [])
    .map((entry) => entryPhrase(t, entry))
    .filter((phrase): phrase is string => phrase !== null)
    .slice(0, 2)
  if (phrases.length > 0) {
    return t('pushNudge.teaser.missed', { items: phrases.join(t('pushNudge.teaser.and')) })
  }

  const followed = teaser?.followed
  if (followed?.location_name || followed?.user_name) {
    const place = followed.location_name ? (followed.location_type === 'Crag' ? 'crag' : 'gym') : null
    const key = place && followed.user_name ? `${place}AndUser` : (place ?? 'user')
    return t(`pushNudge.teaser.followed.${key}`, { place: followed.location_name, user: followed.user_name })
  }

  return t('pushNudge.teaser.generic')
}
